import { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";

 
import InputPagger from "../../helpers/InputPagger";
import InputDateTime from "../../helpers/InputDateTime";
import SortBy from "../../helpers/SortBy";
import MenuTable from "../../helpers/MenuTable";
import QueryDet from "./QueryDet";
import QueryNew from "./QueryNew";
import InputDate from "../../helpers/InputDate";
import DayHistorySet from "./DayHistorySet";
import Csv from "../../exporter/Csv";
import Xlsx from "../../exporter/Xlsx";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";

 
 


function DayHistory(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);



    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
       
        dzien_od: '', 
        dzien_do: '', 
        fraza: '', 

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });
    const [tab, setTab] = useState(null);

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);


    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );

    // Waliduje datę w formacie Y-m-d (YYYY-MM-DD) oraz istnienie daty w kalendarzu.
    const isValidDateYmd = (value) => {
        if(value == null || value == undefined) return false;
        if(typeof value !== "string") return false;

        const v = value.trim();
        if(!/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;

        const parts = v.split("-");
        const y = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10);
        const d = parseInt(parts[2], 10);

        const dt = new Date(Date.UTC(y, m - 1, d));
        return dt.getUTCFullYear() === y && dt.getUTCMonth() === (m - 1) && dt.getUTCDate() === d;
    }


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_news,dziennik_dnia', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(filterParam[filedName] != val && val.length == 0)
        setTab(null);  
    }



    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterClear = () => {
        setFilterParam({    

            dzien_od: '',    
            dzien_do: '',    
            fraza: '',    
            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },

            
            limit: 50,
            page: 1,
        });
        setTab(null);
    }


    const filterApprove = () => {
        if(filterParam.data_od != null && filterParam.data_od.length > 0 && !isValidDateYmd(filterParam.data_od))
        {
            props.mainView.showDialog("Błąd", "Niepoprawna data od. Wymagany format: Y-m-d", "ok", null);
            return;
        }

        if(filterParam.data_do != null && filterParam.data_do.length > 0 && !isValidDateYmd(filterParam.data_do))
        {
            props.mainView.showDialog("Błąd", "Niepoprawna data do. Wymagany format: Y-m-d", "ok", null);
            return;
        }

        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 }); 
        setTab(null);
    }





    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = () => {
       
        setView({...view, ["v"]:"list", ["id"]:-1 }); 
        getTab();
    }


    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }





    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

        
        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć ten wpis " , "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteApproved(id);
                        //--------
        } );
    }

    const goDeleteApproved = (id) => {

 
    

        props.mainView.setProgress(-2);

        var req = {
            id: id
        }

        fetch( Config.url + '/rest_v1_news,dziennik_dnia_del', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Pozycja została usunięta", "ok" , null);                        
                        setTab(null);
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }


   

    var sortList = [  
        {column: "dzien", name: "Dzień"  }, 
    ]
 


    

    if(view.v == 'new')
        {
         
            return <DayHistorySet  userData={props.userData} mainView={props.mainView} id={-1}   onBack={onBack} />
        }



    if(view.v == 'edit')
        {
            var searchRow = null;
            for(var k=0; k<tab.length; k++)
            {
                if(tab[k].id == view.id) { searchRow = tab[k]; break; }
            }
    
            return <DayHistorySet  userData={props.userData} mainView={props.mainView} id={searchRow.id} row={searchRow} onBack={onBack} />
        }

    
    var titleRaport = "Dziennik Dnia"    ;
    if(filterParam.dzien_od.length > 2) titleRaport += " od dnia: "  + filterParam.dzien_od;
    if(filterParam.dzien_do.length > 2) titleRaport += " do dnia: "  + filterParam.dzien_do;

    return (

        <div className="view_content">
         


          



            <div className="bg_center">

                    <div className="table_filter">

                             <div className="filter_controll filter_merge">   
                                        <label>Data (od dnia / do dnia): </label>      <br/>                       
                                        <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                                        <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}   />
                            </div> 

                             <div className="filter_controll filter_merge">   
                                        <label>Fraza (szukaj w treści): </label>      <br/>                       
                                        <InputText   userData={props.userData} value={filterParam.fraza}   valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Fraza: "}   />                                                                  
                                   
                            </div> 


                            <div className="filter_btn">                                  
                                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>

                    </div>


                    <div className="table_widget">      

                              <div className="btn" onClick={changeView} v="new" id="-1"  > dodaj</div>

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />


                                <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport  } />   

                                <Csv tabRef={tab2Ref} title={ titleRaport + ".csv" } />
                                <Xlsx tabRef={tab2Ref} title={ titleRaport  + ".xlsx" } />
                            
                                <Print tabRef={tab2Ref}  title={titleRaport} />


                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />
                    </div>
 

                    <div ref={tabRef} className="gohide">
                            <h3>{titleRaport}</h3>   
                            <table className="table" ref={tab2Ref}>
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td className="">Dzień</td>                                        
                                                <td className="">Godzina</td>                                        
                                                <td className="">Tytuł / Temat</td>                                                                                                                                                                             
                                                <td className="td_right">Opis</td>   
                                                                                                                                                                        
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle}>
                                                            <td className="gocenter">{ix+1}</td>
                                                            <td className="gocenter">{row.dzien }</td>                                                                                                  
                                                            <td className="gocenter">
                                                                 { ( row.godzina == "00:00:00" || row.godzina == "") && <Fragment>Cały dzień</Fragment> }
                                                                 { !( row.godzina == "00:00:00" || row.godzina == "") && <Fragment>{row.godzina}</Fragment> }
                                                            </td>    
                                                            <td className="goleft" onClick={changeView} v="edit" id={row.id} >{row.tytul   }</td>                                                                                                  
                                                            <td className="goleft">{row.opis }</td>                                                                                                                                                                                                                                                   
                                                            
                                                     

                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                            </table>
                    </div>


                    <div className="scorll_x">
                            <table className="table" >
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td className="">Dzień</td>                                        
                                                <td className="">Godzina</td>                                        
                                                <td className="">Tytuł / Temat</td>                                                                                                                                                                             
                                                <td className="td_right">Opis</td>   
                                                <td className="td_option "> </td>                                                                                                                                   
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle}>
                                                            <td className="gocenter">{ix+1}</td>
                                                            <td className="gocenter">{row.dzien }</td>                                                                                                  
                                                            <td className="gocenter">
                                                                 { ( row.godzina == "00:00:00" || row.godzina == "") && <Fragment>Cały dzień</Fragment> }
                                                                 { !( row.godzina == "00:00:00" || row.godzina == "") && <Fragment>{row.godzina}</Fragment> }
                                                            </td>    
                                                            <td className="goleft" onClick={changeView} v="edit" id={row.id} >{row.tytul   }</td>                                                                                                  
                                                            <td className="goleft">{row.opis }</td>                                                                                                                                                                                                                                                   
                                                            
                                                            <MenuTable>
                                                                        <ul>
                                                                            <li onClick={changeView} v="edit" id={row.id} >pokaż</li> 
                                                                            <li onClick={goDelete}  id={row.id} >usuń</li>                                                                           
                                                                        </ul>
                                                            </MenuTable>

                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                            </table>
                    </div>

            </div>


        </div>

    )

}

export default DayHistory;
